(function($) {
  //
  // Section::Accommodation
  //
  $('.room-navigation').on('click', 'a', function(event) {
    event.preventDefault();

    var $el = $(this);
    var $parent = $el.parent('li');

    $parent.addClass('active').siblings().removeClass('active');
  });

  var roomCarousel = new Swiper('.room-gallery-carousel', {
    loop: true,
    autoplay: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    navigation: {
      prevEl: '.room-gallery-prev',
      nextEl: '.room-gallery-next'
    }
  });

  $('.room-navigation a').on('shown.bs.tab', function(event) {
    var index = $(event.target).parent().index();
    try {
      roomCarousel[index].update();
    } catch (error) {
      console.log(error);
    }
  });

  $('#accommodation_preview .collapse').on('shown.bs.collapse', function(event) {
    var index = $(event.target).parent().index();
    try {
      roomCarousel[index].update();
    } catch (error) {
      console.log(error);
    }
  });

  //
  // Section::Offers
  //
  new Swiper('#offers_carousel', {
    speed: 800,
    autoplay: {
      delay: 5000,
    },
    slidesPerView: 2,
    spaceBetween: 20,
    navigation: {
      prevEl: '.offer-button-prev',
      nextEl: '.offer-button-next'
    },
    breakpoints: {
      768: {
        slidesPerView: 3
      },
      992: {
        slidesPerView: 4
      }
    }
  });

  //
  // Section::Review
  //
  new Swiper('#reviews_carousel', {
    loop: true,
    speed: 800,
    autoplay: {
      delay: 5000
    },
    slidesPerView: 1,
    spaceBetween: 20,
    navigation: {
      prevEl: '.swiper-button-prev',
      nextEl: '.swiper-button-next'
    },
    breakpoints: {
      768: {
        slidesPerView: 2
      },
      992: {
        slidesPerView: 3
      }
    }
  });

  //
  // Facebook
  //
  var facebook = document.querySelector('#facebook_widget');
  if (facebook) {
    var pageURL = facebook.getAttribute('data-page');
    var pageQuote = facebook.innerHTML;
    var loadFacebook = () => {
      var html = `<div class="fb-page" data-href="${pageURL}" data-tabs="timeline" data-width="" data-height="350" data-small-header="true" data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="false">${pageQuote}</div>`;
      facebook.innerHTML = html;
    }
  
    if ('IntersectionObserver' in window) {
      var facebookDetect = new IntersectionObserver(( entries ) => {
        entries.forEach(el => {
          if (el.isIntersecting) {
            loadFacebook()
            if (document.readyState === 'complete') {
              FB.XFBML.parse();
              facebookDetect.disconnect()
            }
          }
        })
      }, {
        root: document,
        rootMargin: '0px',
        threshold: 0,
        delay: 500,
      })
    
      facebookDetect.observe( facebook )
    } else {
      loadFacebook();
      FB.XFBML.parse();
    }
  }

  //
  // Instagram
  //
  var $instagram = $('.instagram-feed');
  var $instagramFeed = $instagram.find('ul');
  var loadInstragram = () => {
    var instagram = $.getJSON({
      url: local.ajaxurl,
      data: {
        nonce: local.nonce,
        action: 'instagram_data',
        count: 9
      }
    })
  
    instagram.done(res => {
      if (res.success) {
        var data = res.data;
  
        if (data.meta.code !== 200) {
          $instagramFeed.append(data.meta.error_message);
        }
  
        else {
          var html = '';
          data.data.forEach(item => {
            var url = item.link;
            var image = item.images;
            var thm = {
              src: image.thumbnail.url,
              w: image.thumbnail.width,
              h: image.thumbnail.height,
            }
            var low = {
              src: image.low_resolution.url,
              w: image.low_resolution.width,
              h: image.low_resolution.height
            }
            var img = {
              src: image.standard_resolution.url,
              w: image.standard_resolution.width,
              h: image.standard_resolution.height,
            }
            var caption = item.caption != null ? excape_html(item.caption.text) : '';
            var link = `<a href="${url}" target="_blank" data-fancybox="instagram" data-caption="${caption}">
              <img src="${thm.src}" width="${thm.w}" height="${thm.h}" alt="${caption}" />
            </a>`;
  
            html += `<li>${link}</li>`;
          });
  
          $instagramFeed.append(html);
        }
      }
      
      else {
        $instagramFeed.append(res.data.message);
      }
    })
  }

  if ( $instagram.length ) {
    var detectInstagram = () => {
      var y = window.scrollY || window.pageYOffset
      var win = {
        top: y,
        bottom: y + window.innerHeight,
      }
      var elm = {
        top: $instagram[0].getBoundingClientRect().top + y,
        bottom: $instagram[0].getBoundingClientRect().top + y + $instagram[0].clientHeight,
      }

      if (elm.top <= win.top || elm.top < win.bottom) {
        if ($instagram.hasClass('loading') || $instagram.hasClass('loaded')) return
        $instagram.addClass('loading')
        loadInstragram()
        $instagram.removeClass('loading').addClass('loaded')
      }
    }
    window.addEventListener('scroll', () => {
      requestAnimationFrame( () => {
        detectInstagram()
      } )
    })
    window.addEventListener('load', () => {
      detectInstagram()
    })
  }

  function excape_html( string ) {
    var output = replaceArray( string, [
      ['>', '&gt;'],
      ['<', '&lt;'],
      ['"', '&quot;'],
      ['\n', '<br/>'],
    ] );
    return output;
  }

  function replaceArray( string, object ) {
    var replaceStr = string;
    object.forEach(function(el) {
      var oldStr = new RegExp(el[0], 'gi');
      var newStr = el[1];
      replaceStr = replaceStr.replace(oldStr, newStr);
    });
    return replaceStr;
  }
})(jQuery);